/**
 * external libs
 */
import React from 'react'
/**
 * enums
 */
import DimensionSelectValueById from "../../../../../enums/api/DimensionSelectValueById";
import {Tooltip} from "antd";


export default function WidgetGenderIcon({ result }){
    if(!result){
        return null;
    }

    const iconName = result.member[result.member.length - 1].icon;

    if(!iconName){
        return null
    }


    return (
        <Tooltip placement="top" title={result.member[result.member.length - 1]?.name}>
            <img src={`/image/icon/${iconName}.svg`} alt="gender" style={{width: 18}}/>
        </Tooltip>
    )
}
